export const API_KEY = "at_rDTD1SSL0UoUjymbUcUC2WAotcpYY";
export const API_URL = "https://geo.ipify.org/api/v2/country,city?apiKey=";
